<template>
    <div id="search-filters-settings-form-5" class="d-flex">
        <div class="settings-form-col">
            <label class="field-label">{{ $t('fields.f-religion') }}</label>
            <div id="religion" class="d-flex">
                <multi-select name="religion" :items="religionChoices" :selected="religionUserChoices"></multi-select>
            </div>
            <label class="mt-3 field-label">{{ $t('fields.f-astro-sign') }}</label>
            <div id="astro-sign" class="d-flex">
                <multi-select name="astro-sign" :items="astroSignChoices" :selected="astroSignUserChoices"></multi-select>
            </div>
        </div>
        <div class="settings-form-col">
            <label class="field-label">{{ $t('fields.f-values') }}</label>
            <div id="values" class="d-flex">
                <multi-select name="values" :items="valuesChoices" :selected="valuesUserChoices"></multi-select>
            </div>
            <label class="mt-3 field-label">{{ $t('fields.f-alter-care') }}</label>
            <div id="alter-care" class="d-flex">
                <multi-select name="alter-care" :items="alterCareChoices" :selected="alterCareUserChoices"></multi-select>
            </div>
        </div>
        <div class="settings-form-col">
            <label class="field-label">{{ $t('fields.f-activity') }}</label>
            <div id="activity" class="d-flex">
                <multi-select name="activity" :items="activityChoices" :selected="activityUserChoices"></multi-select>
            </div>
            <label class="mt-3 field-label">{{ $t('fields.f-archangel') }}</label>
            <div id="search-filters-settings-eyes" class="d-flex">
                <multi-select name="archangel" :items="archangelChoices" :selected="archangelUserChoices"></multi-select>
            </div>
        </div>
        <div class="settings-form-col">
            <label class="field-label">{{ $t('fields.f-eat') }}</label>
            <div id="eat" class="d-flex">
                <multi-select name="eat" :items="eatChoices" :selected="eatUserChoices"></multi-select>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from "@/components/shared/fields/MultiSelect.vue";

    export default {
        name: "tab-spiritual",
        components: {
            MultiSelect
        },
        props: {
            fields: {
                type: Object,
                required: true
            },
            userChoices: {
                type: Object,
                required: true
            }
        },
        computed: {
            religionChoices() {
                return this.fields.filter(c => c.slug === 'religion')[0].choices
            },
            religionUserChoices: {
                get() { return this.getUserChoices('religion') },
                set(choice) { this.userChoices.filter(c => c.field_Slug === 'religion')[0].choices = choice }
            },

            astroSignChoices() {
                return this.fields.filter(c => c.slug === 'astro-sign')[0].choices
            },
            astroSignUserChoices: {
                get() { return this.getUserChoices('astro-sign') },
                set(choice) { this.userChoices.filter(c => c.field_Slug === 'astro-sign')[0].choices = choice }
            },

            valuesChoices() {
                return this.fields.filter(c => c.slug === 'values')[0].choices
            },
            valuesUserChoices: {
                get() { return this.getUserChoices('values') },
                set(choices) { this.userChoices.filter(c => c.field_Slug === 'values')[0].choices = choices }
            },

            alterCareChoices() {
                return this.fields.filter(c => c.slug === 'alter-care')[0].choices
            },
            alterCareUserChoices: {
                get() { return this.getUserChoices('alter-care') },
                set(choices) { this.userChoices.filter(c => c.field_Slug === 'alter-care')[0].choices = choices }
            },

            activityChoices() {
                return this.fields.filter(c => c.slug === 'activity')[0].choices
            },
            activityUserChoices: {
                get() { return this.getUserChoices('activity') },
                set(choices) { this.userChoices.filter(c => c.field_Slug === 'activity')[0].choices = choices }
            },

            archangelChoices() {
                return this.fields.filter(c => c.slug === 'archangel')[0].choices
            },
            archangelUserChoices: {
                get() { return this.getUserChoices('archangel') },
                set(choices) { this.userChoices.filter(c => c.field_Slug === 'archangel')[0].choices = choices }
            },

            eatChoices() {
                return this.fields.filter(c => c.slug === 'eat')[0].choices
            },
            eatUserChoices: {
                get() { return this.getUserChoices('eat') },
                set(choices) { this.userChoices.filter(c => c.field_Slug === 'eat')[0].choices = choices }
            }
        },
        methods: {
            getUserChoice(slug) {
                let filtered = this.userChoices.filter(c => c.field_Slug === slug)
                if (filtered.length) {
                    let field = filtered[0]
                    if (field.choices.length) {
                        return field.choices[0]
                    }
                }
                return '';
            },
            getUserChoices(slug) {
                let filtered = this.userChoices.filter(c => c.field_Slug === slug)
                if (filtered.length) {
                    return filtered[0].choices
                }
                return []
            },
        }
    }
</script>